import React from 'react';
import './Services.css';

const services = [
  {
    emoji: '🎬',
    name: 'Instagram Reels',
    desc: 'Scroll-stopping short-form content crafted for maximum reach and engagement on Instagram.',
    tags: ['15–60 sec', 'Trending audio', 'Same-day'],
    price: 'From ₹1,999',
    featured: true,
    badge: 'Most Popular',
    delay: '',
  },
  {
    emoji: '🏢',
    name: 'Brand & Product',
    desc: 'Cinematic brand videos that convert. Perfect for ads, landing pages and social media campaigns.',
    tags: ['Storyboarded', 'Studio-grade', 'Raw files'],
    price: 'From ₹2,999',
    featured: false,
    delay: 'rd1',
  },
  {
    emoji: '🎉',
    name: 'Events & Weddings',
    desc: 'Capture your precious moments in cinematic style — weddings, birthdays, and corporate events.',
    tags: ['Full event', 'Highlights reel', 'RAW footage'],
    price: 'From ₹3,999',
    featured: true,
    badge: 'Most Popular',
    delay: 'rd2',
  },
  {
    emoji: '⭐',
    name: 'Influencer Shoots',
    desc: 'GRWM, OOTD, lifestyle — create content that grows your personal brand and attracts deals.',
    tags: ['Multi-look', 'Location flex', 'Vertical'],
    price: 'From ₹1,999',
    featured: false,
    delay: '',
  },
  {
    emoji: '🍕',
    name: 'Food & Restaurant',
    desc: 'Mouth-watering food films built for delivery apps and Instagram. Steam, sizzle, style.',
    tags: ['Macro shots', 'Steam & sizzle', '30-sec ads'],
    price: 'From ₹1,999',
    featured: false,
    delay: 'rd1',
  },
  {
    emoji: '📦',
    name: 'Custom Packages',
    desc: 'Need something unique? Build your own package. Bulk bookings, retainers, and enterprise deals available.',
    tags: ['Flexible', 'Monthly plans', 'Dedicated creator'],
    price: 'Custom',
    featured: false,
    delay: 'rd2',
  },
];

const handleAnchorClick = (e, href) => {
  e.preventDefault();
  const target = document.querySelector(href);
  if (target) target.scrollIntoView({ behavior: 'smooth' });
};

const Services = () => (
  <section className="services" id="services">
    <div className="container">
      <div className="services-head">
        <div className="reveal">
          <span className="sec-label">What we shoot</span>
          <h2 className="sec-h2">Every Kind of <em>Content,</em><br />On Demand</h2>
        </div>
        <a href="#pricing" className="btn-outline reveal rd1" onClick={(e) => handleAnchorClick(e, '#pricing')}>
          View Pricing →
        </a>
      </div>
      <div className="services-grid">
        {services.map((svc) => (
          <div key={svc.name} className={`svc-card reveal ${svc.delay}${svc.featured ? ' featured' : ''}`}>
            {svc.badge && <div className="svc-badge">{svc.badge}</div>}
            <span className="svc-emoji">{svc.emoji}</span>
            <div className="svc-name">{svc.name}</div>
            <div className="svc-desc">{svc.desc}</div>
            <div className="svc-tags">
              {svc.tags.map((tag) => <span key={tag}>{tag}</span>)}
            </div>
            <div className="svc-price">{svc.price}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Services;
